export class EventsEnvironment {
  public static getName = () => 'benzinga-events';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
